// src/utils/sound.js
let backgroundMusic; // Declarar la variable en el ámbito global

export const playSound = (sound) => {
  const audio = new Audio(sound);
  audio.play();
};

export const playSelectSound = () => {
  playSound(require('../assets/sounds/select.wav'));
};

export const playBackgroundMusic = () => {
  backgroundMusic = new Audio(require('../assets/sounds/battle-music.mp3'));
  backgroundMusic.loop = true;
  backgroundMusic.play();
};

export const stopBackgroundMusic = () => {
  if (backgroundMusic) {
    backgroundMusic.pause();
    backgroundMusic.currentTime = 0;
  }
};